module.exports = __webpack_public_path__ + "download_right-34fa9afc.png";